<template>
    <v-card link flat :class="item.Active ? '' : 'deactivated'" class="rounded-0" tabindex="-1" @click="$emit('click')">
        <v-row no-gutters class="px-3 py-2" align="center">
            <v-col cols="auto" class="pr-3" style="opacity: 0.7">
                {{ item.Id }}
            </v-col>
            <v-col cols="7">
                {{ item.Name }}
            </v-col>
            <v-col :class="item.LinkedCount ? '' : 'disabled--text'">
                <v-icon size="20" :color="item.LinkedCount ? '' : 'disabled'">mdi-link</v-icon>
                {{ item.LinkedCount }}
            </v-col>
            <v-col>
                <v-icon v-text="item.Global ? 'mdi-earth' : 'mdi-earth-off'"
                    :color="item.Global ? 'warning' : 'disabled'" size="20">
                </v-icon>
            </v-col>
        </v-row>
    </v-card>
</template>


<script>
export default {
    name: 'CounterListItem',
    props: {
        item: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss'>
.deactivated {
    background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
    color: var(--v-disabled-darken2) !important;
    text-decoration: line-through !important;
}
</style>